import TemplateView from "../../../TemplateView";
import _ from "underscore";
import {OTHER_USERS_ENTITY_ID} from "../../../constants";
import messageResource from "../../../messageResource";
import Record from "./SummaryRecord";

export default class SummaryRecords extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
        this.state = {
            summaryRecords: []
        }
        this.onStatePropertyChanged("summaryRecords", (summaryRecords) => {
            this.$el.empty();
            const self = this;
            _.each(summaryRecords, function(record) {
                let isOtherUsersEntity = record["userId"] === OTHER_USERS_ENTITY_ID;
                let formattedName = isOtherUsersEntity ? messageResource.getMessage("report.other_users") : record['formattedName'];
                new Record(self.$el, formattedName, isOtherUsersEntity).init().setValue(record['spentTime']);
            });
        })
    }

    useUnderscoreTemplate() {
        return false;
    }

    templateHtml() {
        return "<div class='summaryRecords'/>";
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/SummaryRecords.js